<template>
  <div class="temp-success-page">
    <survey-header surveyType="skincare" />
    <div class="temp-success-content">
      <h1 class="temp-success-title">Analyzing your skin profile...</h1>
      <p class="temp-success-subtitle">
        We're matching your responses and photo to prepare your personalized recommendation in
        <span class="countdown-circle">{{ countdown }}</span> s...
      </p>
      <div class="testimonial-card flex flex-col items-center ">
        <div class="testimonial-text relative">
          <img
            :src="quoteLeft"
            class="quote-mark quote-left"
          />
          I've never been happier with a product and could literally feel the difference of the serum day one.
          <img
            :src="quoteRight"
            class="quote-mark quote-right"
          />
        </div>

        <p class="testimonial-author">Natalie W.</p>
        <p class="testimonial-disclaimer">*Shared by customers who received a personalized formula for review.</p>
      </div>
      <a
        class="view-formula-link"
        @click="redirectNow"
      >
        <u>View your formula now</u>
        <img
          :src="arrowIcon"
          class="arrow"
        />
      </a>
    </div>
  </div>
</template>

<script>
import SurveyHeader from "../components/SurveyHeader.vue";
import { store } from "../service/storeV2.js";
import quoteLeft from "../assets/quote-left.svg";
import quoteRight from "../assets/qutoe-right.svg";
import arrowIcon from "../assets/arrow.png";

export default {
  name: "TempSuccessPage",
  components: { SurveyHeader },
  setup() {
    return { quoteLeft, quoteRight, arrowIcon };
  },
  props: {
    orderType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      countdown: 6,
      timer: null,
    };
  },
  computed: {
    redirectUrl() {
      const questionnaireId = store.temporaryQuestionnaireId;
      const type = this.orderType === "first" ? "first_order" : "reorder";
      return `https://www.regenere.com/products/regenere-customized-face-serum-questionnaire?questionnaire_id=${questionnaireId}&type=${type}`;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.redirectNow();
      }
    }, 1000);
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    redirectNow() {
      if (this.timer) clearInterval(this.timer);
      window.location.href = this.redirectUrl;
    },
  },
};
</script>

<style scoped>
.temp-success-page {
  background-color: #f5f1e7;
  min-height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  overflow-y: auto;
}

.temp-success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 24px;
  max-width: 888px;
  margin: 0 auto;
  gap: 24px;
}

.temp-success-title {
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  font-size: 32px;
  text-align: center;
  letter-spacing: 0.02em;
  background: linear-gradient(90deg, #000 0%, #000 30%, #e3a52a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.temp-success-subtitle {
  font-size: 14px;
  color: #9a9a9a;
  text-align: center;
}

.countdown-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f4eacd;
  color: #d4a843;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}

.testimonial-card {
  width: 100%;
  border-radius: 12px;
  border: 1px solid #dbc49f;
  padding: 32px 24px;
  text-align: center;
}

.quote-mark {
  position: absolute;
  width: 18px;
  height: auto;
}

.quote-left {
  top: 0px;
  left: -10px;
}

.quote-right {
  bottom: -5px;
  right: -8px;
}

.testimonial-text {
  font-style: italic;
  font-size: 24px;
  color: black;
  max-width: 662px;
  /* margin: 0 auto 16px; */
}

.testimonial-author {
  font-size: 16px;
  font-weight: 400;
  color: black;
  margin-bottom: 16px;
  margin-top:16px;
}

.testimonial-disclaimer {
  font-size: 13px;
  color: #9a9a9a;
}

.view-formula-link {
  color: #c8922a;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-underline-offset: 3px;
}

.view-formula-link .arrow {
  margin-left: 4px;
  height: 14px;
  width: auto;
  vertical-align: middle;
  display: inline;
}

@media (min-width: 768px) {
  .temp-success-content {
    padding: 80px 24px;
    gap: 32px;
  }

  .temp-success-title {
    font-size: 48px;
  }

  .temp-success-subtitle {
    font-size: 16px;
  }

  .quote-mark {
    position: absolute;
    width: 24px;
    height: auto;
  }
  .quote-left {
    top: -10px;
    left: -32px;
  }

  .quote-right {
    bottom: 0px;
    right: -24px;
  }
}
</style>
